import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthNotGuard {
  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService,
  ) {}

  getIsLoading(): boolean {
    let isLoading: boolean = true;
    const sub = this.authenticationService.$isLoading.subscribe((loading) => {
      isLoading = loading;
    });
    sub.unsubscribe();
    return isLoading;
  }

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    while (this.getIsLoading()) {
      await new Promise((r) => setTimeout(r, 100));
    }

    let idToken: string | undefined = undefined;
    const sub = this.authenticationService.$idToken.subscribe({
      next: (token: string | undefined) => {
        idToken = token;
      },
    });
    sub.unsubscribe();

    if (idToken) {
      this.router.navigate(['/'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
